module.exports = __webpack_public_path__ + "img/circle-loader.f5ed1559.svg";